<template>
  <div v-if="commonStore.loaderVisible" id="preloder">
    <div class="preloader">
      <div class="preloader-body">
        <div class="cssload-bell">
          <div class="cssload-circle">
            <div class="cssload-inner"></div>
          </div>
          <div class="cssload-circle">
            <div class="cssload-inner"></div>
          </div>
          <div class="cssload-circle">
            <div class="cssload-inner"></div>
          </div>
          <div class="cssload-circle">
            <div class="cssload-inner"></div>
          </div>
          <div class="cssload-circle">
            <div class="cssload-inner"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page">
    <Header />
    <router-view />
    <Footer />
  </div>
  <LoaderOverlay />
</template>

<script setup>
import Header from './components/layout/AppHeader.vue'
import Footer from './components/layout/AppFooter.vue'
import LoaderOverlay from '@/components/common/LoaderOverlay.vue'
import { useCommonStore } from './stores/commonStore';

const commonStore = useCommonStore();

</script>